import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { TipoOperacaoPlanoSaudeModel } from "../model/tipo-operacao-plano-saude.model";

@Injectable()
export class TipoOperacaoPlanoSaudeService {
    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * TipoOperacao Plano de Saúde por id
     * @param id ID da TipoOperacao Plano de Saúde
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "plano-saude/tipo-operacao/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de TipoOperacao Plano de Saúde
     * @param id ID da TipoOperacao Plano de Saúde
     */
    getAll(
        params: Record<string, unknown>
    ): Observable<ApiPaginationResponseDataNonNullable<TipoOperacaoPlanoSaudeModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<TipoOperacaoPlanoSaudeModel>>(
            this.utilitesService.urlPrefix + "plano-saude/tipo-operacao" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Lista de TipoOperacao Plano de Saúde
     * @param id ID da TipoOperacao Plano de Saúde
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "plano-saude/tipo-operacao/search" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de TipoOperacao Plano de Saúde
     * @param id ID da TipoOperacao Plano de Saúde
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "plano-saude/tipo-operacao/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra TipoOperacao Plano de Saúde
     * @param params Json TipoOperacao Plano de Saúde
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "plano-saude/tipo-operacao", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza TipoOperacao Plano de Saúde
     * @param params Json TipoOperacao Plano de Saúde
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "plano-saude/tipo-operacao/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
